import React from 'react'

// components
import { Button, Typography } from '@mui/material'
import dateFnsFormat from 'date-fns/format'
import enums from '../../utils/enums'

// Positions in rowData follow the column order below.
const CONFORMITY_INDEX = 2
const OVERRIDDEN_INDEX = 5

export default function generate({
  t,
  classes,
  onControlClick,
  renderConformity,
  computeControlledByLabel,
}) {
  return [
    {
      name: 'controlNumber',
      label: t('common.number'),
    },
    {
      name: 'controlDate',
      label: t('controls-list.controlDate'),
      options: {
        customBodyRender: (val, tableMeta) => {
          const formatedDate = dateFnsFormat(Date.parse(val), 'dd/MM/yyyy')
          const conformity = tableMeta.rowData[OVERRIDDEN_INDEX]
            ? enums.CONFORMITY.VALID
            : tableMeta.rowData[CONFORMITY_INDEX]
          switch (conformity) {
            case enums.CONFORMITY.INVALID:
              return <Typography color="error">{formatedDate}</Typography>
            case enums.CONFORMITY.VALID:
              return (
                <Typography className={classes.greenText}>
                  {formatedDate}
                </Typography>
              )
            case enums.CONFORMITY.WAITING_CONTROL:
              return (
                <Typography className={classes.orangeText}>
                  {formatedDate}
                </Typography>
              )
            default:
              return <Typography>{formatedDate}</Typography>
          }
        },
      },
    },
    {
      name: 'conformity',
      label: t('common.conformity'),
      options: {
        sort: false,
        customBodyRender: (val, tableMeta) =>
          tableMeta.rowData[OVERRIDDEN_INDEX]
            ? t('conformity.valid-overriden')
            : renderConformity(val),
      },
    },
    {
      name: 'submittedByUser',
      label: t('common.controlBy'),
      options: {
        sort: false,
        customBodyRender: (val, tableMeta) =>
          computeControlledByLabel(tableMeta.rowData[CONFORMITY_INDEX], val),
      },
    },
    {
      name: 'id',
      label: t('common.actions'),
      options: {
        sort: false,
        customBodyRender: (val) => (
          <Button
            className={classes.linkButton}
            variant="text"
            onClick={() => onControlClick(val)}
            color="primary"
          >
            {t('common.see')}
          </Button>
        ),
      },
    },
    {
      name: 'wasValidationOverriden',
      options: {
        display: 'excluded',
      },
    },
  ]
}
